import React, { useRef, useCallback } from 'react';
import { _cs } from '@togglecorp/fujs';
import RawButton from '../RawButton/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function GenericSelectOption(_ref) {
  let {
    optionContainerClassName,
    contentRenderer: ContentRenderer,
    contentRendererParam,
    option,
    onClick,
    onFocus,
    optionKey,
    focusedKey,
    readOnly,
    disabled
  } = _ref;
  const params = contentRendererParam(optionKey, option);
  const {
    containerClassName,
    title,
    ...props
  } = params;
  const isFocused = (focusedKey === null || focusedKey === void 0 ? void 0 : focusedKey.key) === optionKey;
  const divRef = useRef(null);
  const focusedByMouse = useRef(false);
  React.useEffect(() => {
    if (focusedKey && focusedKey.key === optionKey && !focusedKey.mouse && divRef.current) {
      divRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [optionKey, focusedKey, isFocused]);
  const handleClick = useCallback(() => {
    onClick(optionKey, option);
  }, [optionKey, option, onClick]);
  const handleMouseEnter = useCallback(() => {
    if (onFocus) {
      onFocus({
        key: optionKey,
        mouse: true
      });
    }
  }, [onFocus, optionKey]);
  const handleMouseLeave = useCallback(() => {
    focusedByMouse.current = false;
  }, []);
  return /*#__PURE__*/React.createElement(RawButton, {
    elementRef: divRef,
    className: _cs(styles.genericSelectOption, optionContainerClassName, containerClassName, disabled && styles.disabled, readOnly && styles.readOnly),
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    title: title,
    name: optionKey,
    focused: isFocused,
    disabled: disabled || readOnly
  }, /*#__PURE__*/React.createElement(ContentRenderer, props));
}

var GenericSelectOption$1 = genericMemo(GenericSelectOption);

export { GenericSelectOption$1 as default };
//# sourceMappingURL=index.js.map
